import { FaDoorOpen } from "react-icons/fa"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import { useState, useEffect, useCallback, useRef } from "react"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import listPlugin from "@fullcalendar/list"
import multiMonthPlugin from "@fullcalendar/multimonth"
import Tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import Multiselector from "../components/ui/components/Multiselector"
import ServicesCategories from "../utils/plainValues/ServicesCategories"
import FilterSeguimientoClienteDialog from "../components/dialogs/FilterSeguimientoClienteDialog"
import { MdClose } from "react-icons/md"

  const dateColors = {
    fechaIngreso: { bg: "#1976d2", text: "#ffffff", label: "Ingreso", chip: "Fecha ingreso sistema (registro venta)", icon: "🔵" },
    fechaInicio: { bg: "#388e3c", text: "#ffffff", label: "Inicio", chip: "fecha cuando debió/debe iniciar el proyecto", icon: "🟢" },
    fechaInicioManual: { bg: "#f57c00", text: "#ffffff", label: "Inicio Manual", chip: "Fecha de inicio proyecto", icon: "🟠" },
    fechaFin: { bg: "#d32f2f", text: "#ffffff", label: "Fin", chip: "Fecha en la debió/debe finalizar el proyecto", icon: "🔴" },
    fechaEntrega: { bg: "#7b1fa2", text: "#ffffff", label: "Entrega", chip: "Fecha en la que finalizó el proyecto", icon: "🟣" },
    fechaGrabacionCapacitacion: { bg: "#00838f", text: "#ffffff", label: "Grabación capacitación", chip: "Fecha grabación capacitación", icon: "🟦" },
    fechaMigracionOficial: { bg: "#6d4c41", text: "#ffffff", label: "Migración oficial", chip: "Fecha migración oficial", icon: "🟫" },
    llamada: { bg: "#ec4899", text: "#ffffff", label: "Llamada", chip: "Llamada", icon: "📞" },
    reunion: { bg: "#facc15", text: "#111827", label: "Google Meet", chip: "Google Meet", icon: "🟡" },
    requestClientReviews: { bg: "#111827", text: "#ffffff", label: "Cambios cliente", chip: "Solicitud revisiones cliente", icon: "📝" },
  }

const SalidaProyectos = () => {

  const [loadingStatus, setLoadingStatus] = useState(false)
  const requestIdRef = useRef(0)

  const [registers, setRegisters] = useState([])
  const [calls, setCalls] = useState([])
  const [meets, setMeets] = useState([])
  const [services, setServices] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [selectedEventTypes, setSelectedEventTypes] = useState(Object.keys(dateColors))

  const [categories, setCategories] = useState(["Web"])
  const [openClienteDialog, setOpenClienteDialog] = useState(false)
  const [selectedClient, setSelectedClient] = useState(null)

  const getStartAndEndOfMonth = () => { // Obtener el inicio y el fin del mes actual
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // Primer día del mes
    const firstDayNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1); // Primer día del mes siguiente
  
    return {
      start: firstDay.toISOString().split("T")[0], // Formato YYYY-MM-DD
      end: firstDayNextMonth.toISOString().split("T")[0],
    };
  };

  const getServices = useCallback(async () => { 
    try {
      const params = new URLSearchParams({ limit: "0" })
      if (categories?.length > 0) {
        // Payload acepta valores separados por coma para [in]
        params.set('where[categoria][in]', categories.join(','))
      }
      const response = await axios.get(`${BACKEND}/api/servicios?${params.toString()}`)
      setServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }, [categories])

  const { start, end } = getStartAndEndOfMonth()

  const [range, setRange] = useState({ start, end })

  // Para debounce de filtros (evita que cambie getRegisters por cambios del multiselector)
  const selectedServicesRef = useRef([])
  const didMountServicesRef = useRef(false)

  const fetchAll = useCallback(async () => {
    const requestId = ++requestIdRef.current
    try {
      setLoadingStatus(true)

      const startDay = range?.start
      const endDay = range?.end

      const inRangeDay = (isoLike) => {
        if (!isoLike) return false
        const day = new Date(isoLike).toISOString().split("T")[0]
        if (!day) return false
        if (startDay && day < startDay) return false
        if (endDay && day > endDay) return false
        return true
      }

      // 1) Registros (serviciosCotizaciones)
      const baseUrl = `${BACKEND}/api/serviciosCotizaciones`
      
      // Construir query params usando objeto
      const queryParams = {
        limit: 0,
        depth: 2, // Para obtener datos de cotización y servicio
        // Filtro base: estado = Exito
        'where[and][0][cotizacion.estado][equals]': 'Exito',
        // Condiciones OR para cada fecha que debe estar en el rango del mes
        // fechaIngreso
        'where[and][1][or][0][and][0][fechaIngreso][greater_than_equal]': startDay,
        'where[and][1][or][0][and][1][fechaIngreso][less_than_equal]': endDay,
        // fechaInicio
        'where[and][1][or][1][and][0][fechaInicio][greater_than_equal]': startDay,
        'where[and][1][or][1][and][1][fechaInicio][less_than_equal]': endDay,
        // fechaInicioManual
        'where[and][1][or][2][and][0][fechaInicioManual][greater_than_equal]': startDay,
        'where[and][1][or][2][and][1][fechaInicioManual][less_than_equal]': endDay,
        // fechaFin
        'where[and][1][or][3][and][0][fechaFin][greater_than_equal]': startDay,
        'where[and][1][or][3][and][1][fechaFin][less_than_equal]': endDay,
        // fechaEntrega
        'where[and][1][or][4][and][0][fechaEntrega][greater_than_equal]': startDay,
        'where[and][1][or][4][and][1][fechaEntrega][less_than_equal]': endDay,
        // fechaGrabacionCapacitacion
        'where[and][1][or][5][and][0][fechaGrabacionCapacitacion][greater_than_equal]': startDay,
        'where[and][1][or][5][and][1][fechaGrabacionCapacitacion][less_than_equal]': endDay,
        // fechaMigracionOficial
        'where[and][1][or][6][and][0][fechaMigracionOficial][greater_than_equal]': startDay,
        'where[and][1][or][6][and][1][fechaMigracionOficial][less_than_equal]': endDay,
        // 'where[and][1][or][5][and][0][servicio][equals]': selectedService,
      }

      if (selectedClient?.id) {
        // Filtrar por un cliente específico (relación en cotización)
        queryParams['where[cotizacion.cliente][equals]'] = selectedClient.id
      }

      if (categories?.length > 0) {
        // Payload acepta valores separados por coma para [in]
        queryParams['where[servicio.categoria][in]'] = categories.join(',')
      }

      const selected = selectedServicesRef.current || []
      if (selected.length > 0) {
        // Filtrar por servicios seleccionados (relación servicio)
        // Payload acepta valores separados por coma para [in]
        queryParams['where[servicio][in]'] = selected.join(',')
      }

      // Construir query string con URLSearchParams
      const queryString = new URLSearchParams(queryParams).toString()
      const url = `${baseUrl}?${queryString}`

      const regResponse = await axios.get(url)
      const nextRegisters = regResponse?.data?.docs || []

      if (requestId !== requestIdRef.current) return
      setRegisters(nextRegisters)

      // 2) Llamadas (registroLlamadas) cruzadas contra cotizaciones en registers
      const quoteIds = Array.from(
        new Set(nextRegisters.map((r) => r?.cotizacion?.id).filter(Boolean))
      )

      const callsPromise = (async () => {
        if (quoteIds.length === 0) return []
        const baseCallsUrl = `${BACKEND}/api/registroLlamadas`
        const callsParams = {
          limit: 0,
          depth: 1,
        }
        if (selectedClient?.id) {
          callsParams['where[client][equals]'] = selectedClient.id
        }
        if (startDay) {
          callsParams['where[and][0][date][greater_than_equal]'] = new Date(startDay).toISOString()
        }
        if (endDay) {
          callsParams['where[and][1][date][less_than_equal]'] = new Date(endDay).toISOString()
        }
        const callsQS = new URLSearchParams(callsParams).toString()
        const callsRes = await axios.get(`${baseCallsUrl}?${callsQS}`)

        const quoteIdSet = new Set(quoteIds)
        return (callsRes?.data?.docs || []).filter((call) => {
          if (selectedClient?.id) {
            const callClientId =
              typeof call?.client === "string" ? call.client : call?.client?.id
            if (callClientId !== selectedClient.id) return false
          }

          const callQuoteIds = (call?.quotes || [])
            .map((q) => (typeof q === "string" ? q : q?.id))
            .filter(Boolean)

          return callQuoteIds.some((qid) => quoteIdSet.has(qid))
        })
      })()

      // 3) Reuniones (tareasProyectos isMeeting=true status=Finalizado) por servicioCotizacion (register.id)
      const serviceQuoteIds = Array.from(new Set(nextRegisters.map((r) => r?.id).filter(Boolean)))
      const meetsPromise = (async () => {
        if (serviceQuoteIds.length === 0) return []
        const results = await Promise.all(
          serviceQuoteIds.map(async (serviceId) => {
            const meetUrl = `${BACKEND}/api/tareasProyectos?where[serviceId][equals]=${serviceId}&where[isMeeting][equals]=true&limit=0&where[status][equals]=Finalizado`
            const meetRes = await axios.get(meetUrl)
            return meetRes?.data?.docs || []
          })
        )
        return results.flat().filter((m) => inRangeDay(m?.deliverDate || m?.startDate))
      })()

      const [nextCalls, nextMeets] = await Promise.all([callsPromise, meetsPromise])
      if (requestId !== requestIdRef.current) return
      setCalls(nextCalls)
      setMeets(nextMeets)
    } catch (error) {
      console.log(error)
    } finally {
      if (requestId === requestIdRef.current) {
        setLoadingStatus(false)
      }
    }
  }, [categories, range, selectedClient])

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  // Mantener el ref sincronizado con el estado del multiselector
  useEffect(() => {
    selectedServicesRef.current = selectedServices
  }, [selectedServices])

  // Al cambiar categoría, limpiar servicios seleccionados para evitar filtros cruzados
  useEffect(() => {
    setSelectedServices([])
    selectedServicesRef.current = []
    didMountServicesRef.current = false
    setServices([])
  }, [categories])

  // Debounce: esperar 3s antes de filtrar por servicios seleccionados
  useEffect(() => {
    if (!didMountServicesRef.current) {
      didMountServicesRef.current = true
      return
    }

    const timeout = setTimeout(() => {
      fetchAll()
    }, 3000)

    return () => clearTimeout(timeout)
  }, [selectedServices, fetchAll])

  useEffect(() => {
    getServices()
  }, [getServices])

  // Generar eventos del calendario
  const serviceEvents = registers.flatMap((register) => {
    const eventsArray = []
    
    // Función auxiliar para agregar eventos
    const addEvent = (fecha, tipo) => {
      if (fecha) {
        const fechaFormateada = new Date(fecha).toISOString().split('T')[0]
        eventsArray.push({
          id: `${register.id}-${tipo}`,
          title: `${dateColors[tipo].label}: ${register.cotizacion?.cliente?.nombreComercial || 'Cliente'}`,
          start: `${fechaFormateada}T00:00:00`,
          end: `${fechaFormateada}T23:59:59`,
          backgroundColor: dateColors[tipo].bg,
          borderColor: dateColors[tipo].bg,
          textColor: dateColors[tipo].text,
          extendedProps: {
            registerId: register.id,
            tipo: tipo,
            servicio: register.servicio?.name || 'Servicio',
            cliente: register.cotizacion?.cliente?.nombreComercial || 'Cliente',
            description: `${dateColors[tipo].label} - ${register.cotizacion?.cliente?.nombreComercial || 'Cliente'} - ${register.servicio?.titulo || 'Servicio'}`,
            chipContent: dateColors[tipo].chip,
          }
        })
      }
    }

    // Agregar evento por cada tipo de fecha
    addEvent(register.fechaIngreso, 'fechaIngreso')
    addEvent(register.fechaInicio, 'fechaInicio')
    addEvent(register.fechaInicioManual, 'fechaInicioManual')
    addEvent(register.fechaFin, 'fechaFin')
    addEvent(register.fechaEntrega, 'fechaEntrega')
    addEvent(register.fechaGrabacionCapacitacion, 'fechaGrabacionCapacitacion')
    addEvent(register.fechaMigracionOficial, 'fechaMigracionOficial')

    return eventsArray
  })

  const clientReviewEvents = registers.flatMap((register) => {
    const tipo = "requestClientReviews"
    const requests = Array.isArray(register?.requestClientReviews)
      ? register.requestClientReviews
      : []

    if (requests.length === 0) return []

    const clienteNombre = register.cotizacion?.cliente?.nombreComercial || "Cliente"

    return requests.flatMap((req, idx) => {
      const dateValue = req?.date
      if (!dateValue) return []
      const day = new Date(dateValue).toISOString().split("T")[0]
      if (!day) return []

      const details = (req?.details || "").trim()

      return [
        {
          id: `${register.id}-${tipo}-${idx}-${day}`,
          title: `${dateColors[tipo].label}: ${clienteNombre}`,
          start: `${day}T00:00:00`,
          end: `${day}T23:59:59`,
          backgroundColor: dateColors[tipo].bg,
          borderColor: dateColors[tipo].bg,
          textColor: dateColors[tipo].text,
          extendedProps: {
            registerId: register.id,
            tipo,
            cliente: clienteNombre,
            // para tooltip: muestra primero `servicio` si existe
            servicio: details || "Cambios solicitados por el cliente",
            chipContent: dateColors[tipo].chip,
            requestIndex: idx,
          },
        },
      ]
    })
  })

  const callEvents = (calls || []).flatMap((call) => {
    const tipo = "llamada"
    const dateValue = call?.date
    const day =
      typeof dateValue === "string"
        ? dateValue.split("T")[0]
        : new Date(dateValue).toISOString().split("T")[0]

    if (!day) return []

    const clienteNombre =
      (typeof call?.client === "object" && call?.client?.nombreComercial) ||
      (typeof call?.client === "object" && call?.client?.name) ||
      "Cliente"

    return [
      {
        id: `${call.id}-${tipo}`,
        title: `${dateColors[tipo].label}: ${clienteNombre}`,
        start: `${day}T00:00:00`,
        end: `${day}T23:59:59`,
        backgroundColor: dateColors[tipo].bg,
        borderColor: dateColors[tipo].bg,
        textColor: dateColors[tipo].text,
        extendedProps: {
          callId: call.id,
          tipo,
          cliente: clienteNombre,
          chipContent: dateColors[tipo].chip,
        },
      },
    ]
  })

  const meetEvents = (meets || []).flatMap((meet) => {
    const tipo = "reunion"
    const dateValue = meet?.deliverDate || meet?.startDate
    const day =
      typeof dateValue === "string"
        ? dateValue.split("T")[0]
        : new Date(dateValue).toISOString().split("T")[0]

    if (!day) return []

    // Mapear cliente desde registers por serviceId (servicioCotizacion id)
    const serviceId = meet?.serviceId
    const relatedRegister = (registers || []).find((r) => r?.id === serviceId)
    const clienteNombre = relatedRegister?.cotizacion?.cliente?.nombreComercial || "Cliente"
    const meetName = meet?.task?.name || meet?.name || "Reunión"

    return [
      {
        id: `${meet.id}-${tipo}`,
        title: `${dateColors[tipo].label}: ${clienteNombre}`,
        start: `${day}T00:00:00`,
        end: `${day}T23:59:59`,
        backgroundColor: dateColors[tipo].bg,
        borderColor: dateColors[tipo].bg,
        textColor: dateColors[tipo].text,
        extendedProps: {
          meetId: meet.id,
          tipo,
          servicio: meetName, // para tooltip (Tippy muestra servicio || cliente)
          cliente: clienteNombre,
          chipContent: dateColors[tipo].chip,
        },
      },
    ]
  })

  const eventTypeOptions = Object.entries(dateColors).map(([key, value]) => ({
    value: key,
    label: `${value.icon} ${value.label} — ${value.chip}`,
  }))

  const allEvents = [...serviceEvents, ...callEvents, ...meetEvents, ...clientReviewEvents]

  const filteredEvents =
    selectedEventTypes?.length > 0
      ? allEvents.filter((e) => selectedEventTypes.includes(e.extendedProps?.tipo))
      : []

  const totalEvents = filteredEvents.length

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterSeguimientoClienteDialog
        open={openClienteDialog}
        setOpen={setOpenClienteDialog}
        setClient={setSelectedClient}
      />

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex items-center gap-4 py-4">
            <FaDoorOpen className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Salida proyectos</h2>
          </div>
        </div>
      </div>

      {/* Web status */}
      <div className="flex flex-row bg-gray-100 mb-0.5 mt-0.5 pt-1 pb-2 px-4">
        <div className="flex flex-row w-full items-center py-1 justify-center gap-4 overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-center gap-2 overflow-x-auto overflow-y-hidden [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <span className="text-xs font-semibold text-gray-700">Eventos incluídos:</span>
            <span className="text-xs text-gray-700">{totalEvents}</span>
          </div>
          <Multiselector
            title="Categoría"
            allValue="Categorías"
            value={categories}
            handlerChange={setCategories}
            disabled={loadingStatus}
            formControlWidth="12rem"
            menuItemWitdh={200}
            itemWidth="16rem"
            options={ServicesCategories.map((category) => ({value: category.value, label: category.label}))}
          />
          <Multiselector
            title="Servicio"
            value={selectedServices}
            handlerChange={setSelectedServices}
            disabled={loadingStatus}
            formControlWidth="18em"
            menuItemWitdh={180}
            itemWidth="20rem"
            options={services.map((service) => ({value: service.id, label: service.name}))}
          />
          <Multiselector
            title="Tipo evento"
            allValue="Todos"
            value={selectedEventTypes}
            handlerChange={setSelectedEventTypes}
            disabled={loadingStatus}
            formControlWidth="26rem"
            menuItemWitdh={160}
            itemWidth="32rem"
            options={eventTypeOptions}
          />
          {/* Cliente */}
          <div className="flex flex-row items-center justify-center gap-4">
            <label
              htmlFor="cliente"
              className="block text-xs font-medium text-gray-900 whitespace-nowrap"
            >
              Cliente
            </label>

            <div className="flex justify-center gap-2 items-center">
              <button
                type="button"
                onClick={() => setOpenClienteDialog(true)}
                style={{ maxWidth: "220px" }}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] px-2 whitespace-nowrap overflow-hidden text-ellipsis"
                disabled={loadingStatus}
              >
                {selectedClient ? (
                  <span>{selectedClient.nombreComercial}</span>
                ) : (
                  "Todos"
                )}
              </button>

              {selectedClient && (
                <button
                  type="button"
                  onClick={() => setSelectedClient(null)}
                  className="bg-red-600 bg-opacity-10 text-red-600 p-2 rounded-xl"
                  disabled={loadingStatus}
                >
                  <MdClose />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {/* Calendario */}
        <div className="w-full px-4 relative">
          {loadingStatus && (
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded bg-white/60 backdrop-blur-[1px]">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" />
              <span className="text-xs font-medium text-gray-700">Cargando calendario…</span>
            </div>
          )}
          <FullCalendar
            events={filteredEvents}
            eventOrder={"order,start,-duration,title"}
            height="75vh"
            datesSet={(e) => {
              setRange({
                start: e.view.currentStart.toISOString().split("T")[0],
                end: e.view.currentEnd.toISOString().split("T")[0],
              })
            }}       
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              multiMonthPlugin,
            ]}
            moreLinkText={"Ver todos"}
            locale={"es"}
            headerToolbar={{
              start: "title",
              end: "prev,next",
            }}
            buttonText={{
              today: "Hoy",
              month: "Mes",
              year: "Año",
              week: "Semana",
              day: "Día",
              listMonth: "Agenda del mes",
              listDay: "Agenda hoy",
              timeGrid: "Semana",
            }}
            views={{
              timeGridWeek: {
                duration: { days: 7 },
                buttonText: "Semana",
              },
            }}
            initialView={"dayGridMonth"}
            moreLinkHint={true}
            defaultAllDay
            dayMaxEvents={false}
            eventContent={function (arg) {
              let containerEl = document.createElement("div");
              containerEl.classList = "event-container cursor-pointer px-1 py-0.5 rounded hover:opacity-80 transition-opacity";

              let contentEl = document.createElement("p");
              contentEl.classList = "event-content overflow-hidden text-xs font-medium";
              contentEl.innerHTML = `${arg.event.title}`;

              containerEl.appendChild(contentEl);

              // containerEl.addEventListener("click", async function (event) {
              //   if (event.target.classList.contains("event-content")) {
              //     await selectEventToGetCot(arg.event.id);
              //   }
              // });

              return { domNodes: [containerEl] };
            }}
            eventDidMount={(info) => {
              Tippy(info.el, {
                content: info.event.extendedProps?.servicio || info.event.extendedProps?.cliente,
                placement: 'top',
                theme: 'dark',
                animation: 'scale'
              });
            }}
            initialEvents={[]}
          />
        </div>
      </div>

    </div>
  )
}

export default SalidaProyectos
